<div class="p-4 w-full h-full" style="font-family: Open Sans;" (window:resize)="onResize($event)">
    <span class="font-bold text-xl" style="color:#515251">Customer Signature</span>
    <div class="font-normal text-xs mt-3" style="color:#444">{{dialogData.agreementClause}}
    </div>

    <div id="signature-container" class="relative mt-5 w-full" style="border: 2px dashed rgba(115, 115, 115, 0.47);">
        <svc-signature-pad #sigPad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
            (onEndEvent)="drawComplete()" [savedSignature]="dialogData.savedUncroppedSignature">
        </svc-signature-pad>
        <span *ngIf="displayClearSignature" class="cursor-pointer absolute px-3 py-2 text-xs top-2 right-2 rounded-md"
            style=" border: 1px solid #515251; color:#515251" (click)="clearSignature()">
            Clear Signature</span>
        <div class="absolute w-full px-3 flex flex-col justify-center bottom-3 pointer-events-none">
            <span class="bg-black w-full" style="height : 1.5px"></span>
            <span class="mt-3 w-full flex justify-center text-xs">Signature</span>
        </div>
    </div>

    <div class="flex flex-row place-content-end mt-8">
        <span (click)="cancel()"
            class="flex place-items-center place-content-center py-2.5 px-5 rounded-md cursor-pointer"
            style="height: 34px; border: '1px solid #0054A6'; color: #0054A6;">Cancel</span>
        <button (click)="save(signature, uncroppedSignature)"
            class="flex place-items-center place-content-center py-2.5 px-5 rounded-md ml-3 cursor-pointer"
            style="height: 34px" [ngStyle]="{background: signature ? '#0054A6' : '#B6B8B9'}"
            [disabled]="!signature">
            <span class="text-white font-medium text-sm">Sign and Save</span>
        </button>
    </div>
</div>